import Vue from 'vue'
import VueRouter from 'vue-router'
import portal from './portal'
import publish from './publish'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    ...portal,
    ...publish
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js